import { createStore } from "redux";
import reduerce from "./reduser";

const store = createStore(reduerce);


export default store;